var map = {
	"./cat-eats-from-bowl.jpg": "609c",
	"./cavy.jpg": "06f7",
	"./comfort.jpg": "88e2",
	"./dog-cut.jpg": "c004",
	"./dog-food.jpg": "7414",
	"./dog-walking.jpg": "cd50",
	"./logo.png": "9d64",
	"./sign.jpg": "f0a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";